import styled from "styled-components";

import { BREAKPOINTS } from "../../../app/appConstants";

export const Header2Styled = styled.h2`
    font-size: 48px;
    font-weight: 800;
    margin-bottom: 0;
    color: var(--color-white);
    ${({ black }) => black && 'color: var(--color-base);'};
    
    @media(max-width: ${BREAKPOINTS.extraLarge}px) {
        font-size: 42px;
    }
    @media(max-width: ${BREAKPOINTS.large}px) {
        font-size: 32px;
    }
    @media(max-width: ${BREAKPOINTS.small}px) {
        font-size: 24px;
    }
`;

export const ParagraphStyled = styled.p`
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    margin-bottom: 0;
    color: var(--color-white);
    ${({ black }) => black && 'color: var(--color-base);'};
    @media (max-width: ${BREAKPOINTS.medium}px) {
        font-size: 14px;
        line-height: 21px;
    }
`;

export const ParagraphSemiBoldStyled = styled(ParagraphStyled)`
    font-weight: 600;
`;

export const Header3Styled = styled.h3`
    font-size: 36px;
    line-height: 44px;
    font-weight: 700;
    color: var(--color-white);
    ${({ black }) => black && 'color: var(--color-base);'};
    @media (max-width: ${BREAKPOINTS.large}px) {
        font-size: 30px;
        line-height: 36px;
    }
    @media (max-width: ${BREAKPOINTS.medium}px) {
        font-size: 24px;
        line-height: 28px;
    }
    @media (max-width: ${BREAKPOINTS.small}px) {
        font-size: 20px;
        line-height: 24px;
    }
`;